import { Observable, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { SocketService } from '../../../notification/event-centre/core/socket.service';
import { epicDependencies } from '../../../store';

function bind(socketService: SocketService, subj: Subject<string>): void {
    socketService.on('OnProgress', (payload: string) => {
        console.log(
            `------------------------------------------------------------- ${payload}`,
        );
        subj.next(payload);
    });
}

export function setupBindings(): Observable<string> {
    const socketService =
        epicDependencies.injector.get<SocketService>(SocketService);

    const subj = new Subject<string>();

    if (socketService.created) {
        bind(socketService, subj);
        return subj;
    }

    return socketService.didCreate.pipe(
        switchMap(() => {
            bind(socketService, subj);
            return subj;
        }),
    );
}
